import styled from 'styled-components';

import { media } from '../../../styles/media';

export const Container = styled.div`
  position: absolute;
  top: ${props => (props.isOpen ? '0' : '100%')};
  left: 0;
  bottom: 0;
  width: 100%;
  max-width: 480px;
  background-color: ${props => props.theme.color.white};
  box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.08);
  transition: top 300ms ease-in-out, left 350ms ease-in-out;
  z-index: 5;

  ${media.tablet`
    max-width: 320px;
    top: 0;
    left: ${props => (props.isOpen ? '0' : '-320px')};
  `};
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 50%;
  max-height: 320px;
  text-align: center;
  background-color: ${props => props.theme.color.secondary};
  overflow: hidden;

  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.25);
  }

  ${media.tablet`
    max-height: 290px;
  `};
`;

export const Logo = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  max-width: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`;

export const Image = styled.img`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
`;

export const Content = styled.div`
  padding: ${props => props.theme.layout.gutter * 2}px;
  text-align: center;
`;

export const BadgeWrapper = styled.div`
  max-width: 230px;
  margin: 0 auto ${props => props.theme.layout.gutter * 2}px;

  ${media.tablet`
    margin: 0 auto ${props => props.theme.layout.gutter * 2}px;
  `};
`;

export const HoursWrapper = styled.div`
  display: block;
  margin: 0 auto ${props => props.theme.layout.gutter}px;
`;

export const Hours = styled.p`
  font-family: ${props => props.theme.font.medium};
  font-size: 15px;
  text-align: center;
  line-height: 22px;
  color: ${props => props.theme.color.brown} ${media.tablet`
    font-size: 18px;
    text-align: left;
  `};
`;

export const CollectionWrapper = styled.a`
  display: block;
  margin: 0 auto ${props => props.theme.layout.gutter * 2}px;
  color: ${props => props.theme.color.white};
  text-align: center;
  text-decoration: none;

  .collection {
    justify-content: center;
  }
`;

export const IconWrapper = styled.div`
  display: inline-block;
  width: ${props => props.theme.layout.gutter * 2}px;
  height: ${props => props.theme.layout.gutter * 2}px;
  border: 1px solid ${props => props.theme.color.secondary};
  border-radius: 50%;
  vertical-align: middle;
`;

export const Number = styled.p`
  display: inline-block;
  margin: 0 ${props => props.theme.layout.gutter / 2}px;
  font-family: ${props => props.theme.font.medium};
  font-size: 15px;
  color: ${props => props.theme.color.brown};
  vertical-align: middle;

  ${media.tablet`
    font-size: 18px;
  `};
`;

// Close
export const Wrapper = styled.div`
  position: absolute;
  top: ${props => props.theme.layout.gutter}px;
  right: ${props => props.theme.layout.gutter}px;
  padding: ${props => props.theme.layout.gutter / 2}px;
  width: ${props => props.theme.layout.gutter}px;
  height: ${props => props.theme.layout.gutter}px;
  cursor: pointer;
  z-index: 20;
`;

export const Cross = styled.div`
  position: absolute;
  top: 2px;
  right: 8px;
  width: 2px;
  height: ${props => props.theme.layout.gutter / 1.5}px;
  ${props =>
    props.rotation
      ? 'transform: rotate(' + props.rotation + 'deg);'
      : null} transform-origin: center;
  background-color: ${props => props.theme.color.white};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  z-index: 0;
`;
